import { LabelTitle } from "./style";

export const Label = ({ label }) => {
  return <LabelTitle> {label}</LabelTitle>;
};
